<template>
    <ul class="tw:flex tw:flex-col tw:md:flex-row tw:p-0 tw:mb-4 tw:list-none tw:bg-[#ededed] tw:overflow-hidden">
        <li class="altcolor-content tw:flex tw:w-full tw:md:w-[25%] tw:items-center tw:justify-center tw:flex-none">
            <div data-test="entrada-titulo" class="text-bold oswald text-uppercase m-0 tw:text-center tw:text-white tw:p-4">
                {{ index + 1 }}. {{ titulo }}
                <small v-if="subtitulo" data-test="entrada-subtitulo" class="tw:block tw:text-[10px] tw:normal-case">({{ subtitulo }})</small>
            </div>
        </li>

        <li class="tw:flex-grow tw:flex tw:flex-col tw:justify-center tw:p-4 tw:md:p-6">
            <div class="tw:flex tw:flex-wrap tw:md:flex-nowrap tw:items-center tw:justify-between tw:mb-2 tw:w-full tw:gap-3">
                <div class="h5 text-bold oswald text-uppercase m-0">
                    <slot name="ubicacion">
                        {{ ubicacionPrincipal }}
                    </slot>
                </div>

                <div class="tw:flex tw:items-baseline tw:gap-2">
                    <span class="tw:text-[10px] tw:font-bold tw:text-gray-400 tw:uppercase">{{ $t('general.precio') }}:</span>
                    <span class="h4 text-bold m-0">{{ precio | formatear_precio }}</span>
                </div>
            </div>

            <slot name="extra"></slot>

            <SeguroEntradasComponent
                v-if="conSeguro"
                :selected="selected"
                :importe_seguro="importeSeguro"
                :loading="loading"
                @handleSeguro="handleSeguro"
            />
        </li>
    </ul>
</template>

<script setup>
    import { useSeguroEntrada } from '@/composables/front/events/seguros/useResumenItem'
    import SeguroEntradasComponent from './SeguroEntradasComponent.vue'

    const emit = defineEmits(['handleSeguro'])

    const props = defineProps({
        index: Number,
        subtitulo: String,
        entrada: {
            type: Object,
            required: true
        },
        documentacionComprador: Object,
        loading: Boolean
    })

    const {
        titulo,
        precio,
        importeSeguro,
        conSeguro,
        selected,
        handleSeguro
    } = useSeguroEntrada(props, emit)
</script>
